import * as React from 'react';
import { LinkText } from '@origin-digital/style-guide';
import { Box } from '@origin-digital/layout';

const BackButton = ({ history }) => (
  <Box display="flex" justifyContent="center" marginTop={8} marginBottom={5}>
    <LinkText
      componentType="link"
      label="back-button"
      color="red"
      data-id="back-button"
      href={'#'}
      onClick={() => {
        history.goBack();
      }}
      text="Back"
    />
  </Box>
);

export { BackButton };
